// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"8a4f2321","59":"75a044ee","188":"288f40ed","347":"cecb34f6","479":"50cc6fac","722":"60bc0691"}[chunkId] + ".chunk.js";
};